import React from "react";
import { Text, StyleSheet } from "react-native";
const escapeRegex = string => string.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
const getMarkup = (input, options) => {
  const {
    bold: boldDelimiter,
    italic: italicDelimiter,
    strikeThrough: strikeThroughDelimiter
  } = {
    bold: "**",
    italic: "_",
    strikeThrough: "~~",
    ...options
  };
  const output = [];
  const regex = new RegExp(`(${escapeRegex(boldDelimiter)}|${escapeRegex(italicDelimiter)}|${escapeRegex(strikeThroughDelimiter)})`, "g");
  let bold = false;
  let italic = false;
  let strikeThrough = false;
  const text = input.split(regex).reduce((a, b) => {
    if (b === boldDelimiter) {
      if (bold) {
        if (a !== "") {
          output.push({
            text: a,
            bold,
            italic,
            strikeThrough
          });
        }
        bold = false;
      } else {
        output.push({
          text: a,
          bold,
          italic,
          strikeThrough
        });
        bold = true;
      }
      return "";
    } else if (b === italicDelimiter) {
      if (italic) {
        if (a !== "") {
          output.push({
            text: a,
            bold,
            italic,
            strikeThrough
          });
        }
        italic = false;
      } else {
        output.push({
          text: a,
          bold,
          italic,
          strikeThrough
        });
        italic = true;
      }
      return "";
    } else if (b === strikeThroughDelimiter) {
      if (strikeThrough) {
        if (a !== "") {
          output.push({
            text: a,
            bold,
            italic,
            strikeThrough
          });
        }
        strikeThrough = false;
      } else {
        output.push({
          text: a,
          bold,
          italic,
          strikeThrough
        });
        strikeThrough = true;
      }
      return "";
    } else {
      return a + b;
    }
  }, "");
  if (text !== "") {
    output.push({
      text: text,
      bold: false,
      italic: false,
      strikeThrough: false
    });
  }
  return output;
};
export default (function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    textParser: (text, _ref) => {
      let {
        style
      } = _ref;
      const inheritedStyle = style ? StyleSheet.flatten(style) : {};
      return getMarkup(text, options).map((_ref2, index) => {
        let {
          text,
          bold,
          italic,
          strikeThrough
        } = _ref2;
        return /*#__PURE__*/React.createElement(Text, {
          key: index,
          style: [{
            fontStyle: italic ? "italic" : inheritedStyle.fontStyle,
            fontWeight: bold ? "bold" : inheritedStyle.fontWeight,
            textDecorationLine: strikeThrough ? "line-through" : inheritedStyle.textDecorationLine
          }]
        }, text);
      });
    }
  };
});
//# sourceMappingURL=index.js.map